export const ON_PERSISTENT_VALUE_CHANGED = 'dialogs@ON_PERSISTENT_VALUE_CHANGED';